import {Moment} from 'moment';
import dayjs, {Dayjs} from 'dayjs';
import {DateFormat} from 'utils/datetime/DateFormat';

export default function formatMoment(value: Moment | undefined) {
  if (!value) {
    return 'Never';
  } else {
    return value.calendar(null, {
      sameDay: '[Today]',
      lastDay: '[Yesterday]',
      nextDay: '[Tomorrow]',
      lastWeek: 'MM/DD/YYYY',
      nextWeek: 'MM/DD/YYYY',
      sameElse: 'MM/DD/YYYY',
    });
  }
}

export function formatDate(value: Dayjs | undefined) {
  if (!value) {
    return 'Never';
  }

  const today = dayjs();
  if (today.isSame(value, 'day')) return 'Today';
  if (today.subtract(1, 'day').isSame(value, 'day')) return 'Yesterday';
  if (today.add(1, 'day').isSame(value, 'day')) return 'Tomorrow';
  return value.format(DateFormat.MM_DD_YYYY);
}
